import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import api from '../api/axios';

// Une seule synchro par chargement d'application (évite de spammer à chaque navigation).
let synced = false;

/**
 * Peuple l'annuaire PIO (``signeplus_pio``) au login : upsert silencieux du profil
 * Microsoft Graph (``/me``) vers ``PUT /crm/me/pio-profile``. On n'envoie PAS de
 * ``booking_url`` → le backend préserve le lien Bookings saisi manuellement.
 * Best-effort : tout échec est ignoré (jamais bloquant pour l'app).
 */
export function usePioDirectorySync(): void {
  const { instance, accounts } = useMsal();

  useEffect(() => {
    if (synced || !accounts[0]) return;
    synced = true;
    (async () => {
      try {
        const token = await instance.acquireTokenSilent({
          scopes: ['User.Read'],
          account: accounts[0],
        });
        const resp = await fetch('https://graph.microsoft.com/v1.0/me', {
          headers: { Authorization: `Bearer ${token.accessToken}` },
        });
        if (!resp.ok) return;
        const me = await resp.json();
        await api.put('/crm/me/pio-profile', {
          display_name: me.displayName ?? null,
          job_title: me.jobTitle ?? null,
          phone: me.mobilePhone ?? null,
          department: me.department ?? null,
          // booking_url volontairement omis → préservé côté backend
        });
      } catch {
        // best-effort : l'annuaire se peuplera à la prochaine connexion
      }
    })();
  }, [instance, accounts]);
}
